import { PlatformRole } from "@proto/gen/users/v1/service"

/**
 * Platform-wide role tier, mirroring the backend's apps/api-core/src/auth/
 * platform-roles.ts. Separate axis from CustomerGroup (see ./customer-groups.ts).
 *
 * Rank: LOWER = strictly MORE privileged (global_admin is most privileged).
 * UNSPECIFIED means "no platform access" and ranks as least privileged.
 * NOTE: inverse direction from CustomerGroup GROUP_RANK (which uses >=).
 */
const PLATFORM_ROLE_RANK: Record<PlatformRole, number> = {
  [PlatformRole.UNSPECIFIED]: Number.POSITIVE_INFINITY,
  [PlatformRole.GLOBAL_ADMIN]: 0,
  [PlatformRole.GLOBAL_OPS]: 500,
  [PlatformRole.TRADER]: 800,
}

/** True if `held` is `required` or more privileged (lower rank). */
export function platformRoleSatisfies(
  held: PlatformRole | undefined,
  required: PlatformRole
): boolean {
  if (held === undefined) return false
  return PLATFORM_ROLE_RANK[held] <= PLATFORM_ROLE_RANK[required]
}

/** True if the role grants any platform/admin access at all. */
export function isPlatformUser(role: PlatformRole | undefined): boolean {
  return role !== undefined && role !== PlatformRole.UNSPECIFIED
}

/** Maps a PlatformRole enum value to its display label. */
export const PLATFORM_ROLE_LABEL: Record<PlatformRole, string> = {
  [PlatformRole.UNSPECIFIED]: "—",
  [PlatformRole.GLOBAL_ADMIN]: "Global admin",
  [PlatformRole.GLOBAL_OPS]: "Global ops",
  [PlatformRole.TRADER]: "Trader",
}
